import { Box } from '@material-ui/core';
import { useAppContext, useDrawerContext } from '../../../core/contexts';
import { useTranslation } from 'react-i18next';
import Alerts from './Alerts';
import styles from './Navbar.module.scss';
import classnames from 'classnames';
import { useHistory } from 'react-router-dom';
import { isVisitor } from 'core/utils/roles';

const UserInfo: React.FC = () => {
    const { user } = useAppContext();
    const { t } = useTranslation();
    const { drawerOpen } = useDrawerContext();
    const {
        user: { login, prenom, nom, account },
        logout,
    } = useAppContext();

    const history = useHistory();

    const gotToProfile = () => {
        history.push('/utilisateurs/modifier');
    };

    return (
        <Box display="flex" justifyContent="flex-end" alignItems="center" className={classnames(styles.header__userinfo, drawerOpen ? styles.drawer__open : styles.drawer__close)}>
            <Box display="flex" flexDirection="column" justifyContent="center" className="mr-4">
                <Box display="flex" justifyContent="flex-end" alignItems="baseline">
                    <Box component="span" className={styles.header__userinfo__name}>
                        {t('header.userInfo.welcome')}&nbsp;
                        <Box component="span" className={styles.header__userinfo__bold} data-test="username">
                            {prenom !== 'APP_PRENOM' ? `${prenom} ${nom}` : ''}
                            {account && account !== '' && <Box component={'span'}> ({account})</Box>}
                        </Box>
                    </Box>
                </Box>
                <Box display="flex" justifyContent="flex-end" className={styles.header__userinfo__actions}>
                    {!isVisitor(user) ? (
                        <Box className={styles.header__userinfo__actions__logout} onClick={() => gotToProfile()}>
                            <Box component="span" className="fas fa-address-card" />
                            <Box component="span" className="ml-1 mr-4">
                                {t('header.userInfo.profile')}
                            </Box>
                        </Box>
                    ) : (
                        <Box className={styles.header__userinfo__actions__visitor}>
                            <Box component="span" className="fas fa-address-card" />
                            <Box component="span" className="ml-1 mr-4">
                                VISITEUR
                            </Box>
                        </Box>
                    )}
                    <Box className={styles.header__userinfo__actions__logout} onClick={() => logout()}>
                        <Box component="span" className="fas fa-sign-out-alt" />
                        <Box component="span" className="ml-1">
                            {t('header.userInfo.logout')}
                        </Box>
                    </Box>
                </Box>
            </Box>
            <Alerts login={login} />
        </Box>
    );
};

export default UserInfo;
